const MONTH_DAY_YEAR_COUNTRIES = ['us', 'ca'];

function isMonthDayYearCountry(country) {
    return MONTH_DAY_YEAR_COUNTRIES.includes(country);
}

export { isMonthDayYearCountry };
